import { render, staticRenderFns } from "./SupportTicketDialogReferredOn.vue?vue&type=template&id=b3322d12"
import script from "./SupportTicketDialogReferredOn.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogReferredOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports